import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../store';
import seluxLogo from '../../../icons/selux-logo';

@customElement('specsheet-head')
export class SpecsheetHead extends connect(store)(LitElement) {

	static styles = css`

		:host {
			display: flex;
			justify-content: space-between;
			justify-self: flex-start;
			flex-direction: row;
			padding-bottom: var(--specsheet-small-gap);
			margin: var(--specsheet-medium-gap) var(--specsheet-small-gap);
		}

		.headline {
			display: flex;
			width: 100%;
		}

		.flex-item.logo {
			display: table-cell;
			margin: 0;
			width: 10vw;
		}

		.flex-item.title {
			display: table-cell;
			padding-top: 25px;
			width: 88vw;
		}

		.logo {
			width: 78px;
		}

		@media (min-width: 768px) {
			/*bp-small*/
			:host {
				margin: var(--specsheet-medium-gap) var(--specsheet-large-gap) 0 var(--specsheet-large-gap);
			}
		}

		.title {
			font: var(--font-specsheet-print-title-bold);
			color: var(--color-black);
			padding-bottom: var(--specsheet-small-gap);
			margin: 0;
			line-height: 1.2;
			letter-spacing: 1px;
		}

		.subtitle {
			margin: 0;
			font: var(--font-specsheet-light);
			color: var(--color-black);
			text-transform: uppercase;
		}

		.subtitle a {
			color: var(--color-black);
			text-decoration: none;
		}

		@media print {
			:host {
				margin: 0;
			}

			h2.title {
				font: var(--font-specsheet-print-title-bold);
				padding-bottom: var(--specsheet-print-small-gap);
			}

			.subtitle {
				font: var(--font-specsheet-print-light);
			}

			.flex-item.logo {
				display: table-cell;
				margin: 0;
				margin-right: 15px;
				width: 10vw;
			}
		}

    `
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	stateChanged(state) {
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.shortArticleNumber = state.shortArticleNumber.data;
		this.status = state.status;
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
		this.shortNumberBasicDimmingID = state.shortNumber.data.BasicDimmingID ?? '';

	}


	render() {
		let shortNumber = this.shortNumberProductModel;
		if (this.shortNumberBasicDimmingID !== '') {
			shortNumber = this.shortNumberProductModel + ' - ' + this.shortNumberBasicDimmingID;
		}
		return html`
			<div class="headline">
				<div class="flex-item title">
					<h2 class="title">${this.status.family === 'TheLine' ? 'Line' : this.status.family}
						<trans-label key="HS_HousingType" context="FV"></trans-label>
					</h2>
					<h3 class="subtitle">
						${when(
							this.shortNumberProductModel !== '',
							() => html`<a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}">${shortNumber}</a>`,
							() => html``
						)}
					</h3>
				</div>
				<div class="flex-item logo">
					<div class="logo">
						${seluxLogo}
					</div>
				</div>
			</div>

		`;
	}
}
